import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GenerateEmailRequest, LanguageEnum } from 'pco-product-service-internal-consumer';
import { generateMemberCodeThunk } from 'reducers/memberCodeStatusReducer';

export const initialGenerateCodeRequest: GenerateEmailRequest = {
  termsAndCondition: false,
  partnerEmail: {
    language: LanguageEnum.En,
  },
};

const generateCodeDetailsSlice = createSlice({
  name: 'GENERATE_CODE_DETAILS',
  initialState: initialGenerateCodeRequest,
  reducers: {
    setTermsAndCondition: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        termsAndCondition: action.payload,
      };
    },
    setSelectedLanguage: (state, action: PayloadAction<LanguageEnum>) => {
      return {
        ...state,
        partnerEmail: {
          language: action.payload,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(generateMemberCodeThunk.rejected, (state) => {
      return { ...state, termsAndCondition: false };
    });
    builder.addCase(generateMemberCodeThunk.fulfilled, (state) => {
      return { ...state, termsAndCondition: false };
    });
  },
});

export const { setTermsAndCondition, setSelectedLanguage } = generateCodeDetailsSlice.actions;
export default generateCodeDetailsSlice.reducer;
